import { Clock } from "./Clock";
import { MatchID } from "./MatchID";
import { Name } from "./Name";
import { Versus } from "./Versus";
import { Card } from "./Card";
import { Lineup } from "./Lineup";
import { PlayerScored } from "./PlayerScored";
import { Substitution } from "./Substitution";
import { Score } from "./Score";
import { Penalties } from "./Penalties";
import { TwoSubstitution } from "./TwoSubstitution";
import { ThreeSubstitution } from "./ThreeSubstitution";
import { Formation } from "./Formation";
import { TeamTicker } from "./TeamTicker";
import { FFStats } from "./FFStats";
import { POTM } from "./POTM";
import { TeamStat } from "./TeamStat";
import { Group } from "./Group";
import { Fixtures } from "./Fixtures";
import { TeamArrival } from "./TeamArrival";
import { TeamSponsor } from "./TeamSponsor";
import { Referee } from "./Referee";
import { RefereeAssistants } from "./RefereeAssistants";
import { FFSponsor } from "./FFSponsor";
import { HTFTBug } from "./HT_FT_Bug";
import { Standings } from "./Standings";
import { Attendance } from "./Attendance";
import { Commentators } from "./Commentators";
import { GoalUpdate } from "./GoalUpdate";
import { TouchMap } from "./TouchMap";
import { AverageFormation } from "./AverageFormation";
import { PassMap } from "./PassMap";
import { ShotMap } from "./ShotMap";
import { PenaltyHistory } from "./PenaltyHistory";
import { LTMatchDelayed } from "./LTMatchDelayed";
import { FFCustomSlate } from "./FFCustomSlate";
import { LTMatchAbandoned } from "./LTMatchAbadoned";
import { LTMatchPostponed } from "./LTMatchPostponed";
import { FFTechnicalSlate } from "./FFTechnicalSlate";
import { FFWeatherSlate } from "./FFWeatherSlate";
import { FFPostponedSlate } from "./FFPostponedSlate";
import { FFCancelledSlate } from "./FFCancelledSlate";
import { LTMatchStats } from "./LTMatchStats";
import { LTActionAreas } from "./LTActionAreas";
import { MiniStandings } from "./MiniStandings";
import { LTZonesOfControl } from "./LTZonesOfControl";
import { LTChampions } from "./LTChampions";
import { CustomInsight } from "./CustomInsight";
import { PlayerStats } from "./PlayerStats";
import { PlayerStatsComparison } from "./PlayerStatsComparison";
import { VAR } from "./VAR";
import { ClockInformation } from "./ClockInformation";
import { PlayerHeatmap } from "./HeatmapPlayer";
import { PIP_Fixtures } from "./PIP_Fixtures";
import { LTDoublePromoted } from "./LTDoublePromoted";
import { LTPromoted } from "./LTPromoted";
import { GoalSponsor } from "./GoalSponsor";
import { ScoreStats } from "./ScoreStats";
import {  DEBUGCLOCK } from "./Debug_Clock";

export default function graphics({
  preview,
  animate,
  update,
  animateOff,
  triggerAnimation,
  clearPreview,
}) {
  return [
    new MatchID({ preview, animate, update, animateOff }),
    new Versus({ preview, animate, update, animateOff, triggerAnimation }),
    new Clock({ preview, animate, update, animateOff, triggerAnimation }),
    new Name({ preview, animate, update, animateOff, triggerAnimation }),
    new Card({ preview, animate, update, animateOff, triggerAnimation }),
    new Lineup({ preview, animate, update, animateOff, triggerAnimation }),
    new Formation({ preview, animate, update, animateOff, triggerAnimation }),
    new PlayerScored({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new Substitution({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new Score({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new Penalties({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
    }),
    new TwoSubstitution({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new ThreeSubstitution({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new TeamTicker({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new FFStats({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new POTM({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new TeamStat({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new Group({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new Fixtures({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new TeamArrival({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new TeamSponsor({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new Referee({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new RefereeAssistants({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new FFSponsor({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new HTFTBug({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new Standings({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new MiniStandings({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new Attendance({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new Commentators({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new GoalUpdate({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new TouchMap({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new AverageFormation({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new PassMap({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new ShotMap({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new PenaltyHistory({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new LTMatchDelayed({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new FFCustomSlate({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new LTMatchAbandoned({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new LTMatchPostponed({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new FFTechnicalSlate({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new FFWeatherSlate({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new FFPostponedSlate({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new FFCancelledSlate({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new LTMatchStats({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new LTActionAreas({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new LTZonesOfControl({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new LTChampions({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new CustomInsight({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new PlayerStats({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new PlayerStatsComparison({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new VAR({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new ClockInformation({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new PlayerHeatmap({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new PIP_Fixtures({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new LTDoublePromoted({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new LTPromoted({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
        new GoalSponsor({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new ScoreStats({
      preview,
      animate,
      update,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
    new DEBUGCLOCK({
      preview,
      animate,
      animateOff,
      triggerAnimation,
      clearPreview,
    }),
  ];
}
